export enum AlertActionTypes {
  GET_ALERTS_PENDING = '@@alert/GET_ALERTS_PENDING',
  GET_ALERTS_SUCCESS = '@@alert/GET_ALERTS_SUCCESS',
  GET_ALERTS_ERROR = '@@alert/GET_ALERTS_ERROR'
}
